import React, { useState, useEffect } from 'react';
import {Row, Col, Alert} from 'react-bootstrap';
import {resolvePath, useNavigate, useParams} from "react-router-dom";
import {Container, Button} from "react-bootstrap";
import CheckAdmin from "./checkAdmin";
import TextEditor from "./TextEditor";
import Swal from 'sweetalert2';

export function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}`;
}

function formatNumber(value, locale = 'cs-CZ', style = 'decimal', currency = 'CZK') {
    return new Intl.NumberFormat(locale, {
        style: style,
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
}


const sanitizeContent = (content) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Odebere všechny inlinové styly barvy
    const elements = tempDiv.querySelectorAll('*');
    elements.forEach(el => {
        if (el.style.color) {
            el.style.color = ''; // Resetuje barvu textu
        }
    });

    return tempDiv.innerHTML;
};

const handleNewCharacterModal = async (thisBook, newCharModalClose) => {
    const nameInput = document.getElementById("name").value.trim();
    const imgInput = document.getElementById("img").value.trim();
    const detailInput = document.getElementById("detail").value ? document.getElementById("detail").value.trim() : '';

    if (!nameInput || !imgInput) {
        Swal.fire({
            text: "Všechna pole jsou povinná!",
            icon: "error"
        });
        return;
    }

    try {
        const response = await fetch(`https://api.lexikonn.eu/mau/addcharacter.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                bookId: thisBook.book.id,
                name: nameInput,
                img: imgInput,
                detail: detailInput,
            }),
        });

        const data = await response.json();

        if (response.ok) {
            Swal.fire({
                text: "Postava přidána",
                icon: "success"
            })
            .then(() => {
                window.location.reload();
            });
        } else {
            Swal.fire({
                text: `Chyba při přidávání: ${data.error || "Neznámá chyba"}`,
                icon: "error"
            });
        }
    } catch (error) {
        console.error("Chyba při odesílání dat:", error);
        Swal.fire({
            text: "Nepodařilo se přidat postavu. Zkontroluj připojení nebo API.",
            icon: "error"
        });
    }
};



function deleteChar(char) {
    Swal.fire({
        title: "Opravdu smazat tuto postavu?",
        text: "Tento krok není možné vzít zpět",
        showCancelButton: true,
        confirmButtonColor: "#0b9507",
        cancelButtonColor: "#d33",
        cancelButtonText: "Zrušit",
        confirmButtonText: "Smazat",
        icon: "question"
    })
    .then((result) => {
        if (result.isConfirmed) {
            try {
                fetch(`https://api.lexikonn.eu/mau/deletechar.php?char=${char}`, {
                    method: "POST"
                })
                    .then(response => {
                        if (response.ok) {
                            Swal.fire({
                                title: "Postava smazána",
                                icon: "success",
                                timer: 3000
                            })
                                .then(() => {
                                    window.location.reload();
                                })
                        }
                    })
            }
            catch (error) {
                console.log(error);
            }
        }
    })
}

function nl2br(text) {
    if (!text) return null;

    return text.split('\n').map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br />
        </React.Fragment>
    ));
}

function publicBook(arg, id) {
    try {
        fetch(`https://api.lexikonn.eu/mau/public.php?book=${id}&public=${arg}`, {
            method: 'POST',
        });
        window.location.reload()
    }
    catch (error) {
        console.log(error);
    }
}
function OneBook() {
    const [newText, setNewText] = useState('');
    const [newTextChapter, setNewTextChapter] = useState('');
    const [thisBook, setBookData] = useState(null);
    const { id, chapter } = useParams();
    const [allChaptersLinks, setallChaptersLinks] = useState([]);
    const navigate = useNavigate();

    const handleInsert = () => {
        const content = document.getElementById("content").innerText;
        setNewText(content);
    };

    const handleCopy = (e) => {
        e.preventDefault();
    }

    function NextChapter() {
        let thischapter = chapter;
        thischapter++;
        //navigate(`/book/${id}/${thischapter}`);
        window.location.href=`/book/${id}/${thischapter}`
    }

    function PrevChapter() {
        let thischapter = chapter;
        thischapter--;
        //navigate(`/book/${id}/${thischapter}`);
        window.location.href=`/book/${id}/${thischapter}`
    }

    const twitter = "https://twitter.com/intent/tweet?url="+window.location.href;
    const facebook = "https://www.facebook.com/sharer/sharer.php?u="+window.location.href;

    const sendNewText = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://api.lexikonn.eu/mau/newtext.php?book=${id}&storychapter=${chapter}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ newText, chapter, newTextChapter }),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Chyba při odesílání textu.');
            }
            window.location.reload()
        } catch (error) {
            console.error('Chyba:', error);
            Swal.fire({
                text: 'Nastala chyba při odesílání textu: ' + error.message,
                icon: "error"
            })
        }
    };

    const deleteStory = async (bookId, e) => {
        e.preventDefault();
        try {
            const response = await fetch("https://api.lexikonn.eu/mau/delbook.php", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ id:bookId })
            });
            window.location.href = "/"
        }
        catch (error) {
            console.error('Chyba:', error);
        }
    }

    useEffect(() => {
        fetch(`https://api.lexikonn.eu/mau/getbook.php?book=${id}&storychapter=${chapter}&usr=${localStorage.getItem("mau_user")}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data.error == "no_chapter") {
                    window.location.href="/";
                    return;
                }
                if (String(data.public) === "0" && !CheckAdmin()) {
                    window.location.href = "/"
                    return;
                }
                setBookData(data);
                handleInsert()
            })
            .catch(error => console.error('Chyba při načítání dat:', error));
    }, [id]);

    useEffect(() => {
        fetch(`https://api.lexikonn.eu/mau/getAllChapters.php?book=${id}`)
            .then(response => response.json())
            .then(data => {
                console.log("📢 API odpověď:", data);
                setallChaptersLinks(Array.isArray(data) ? data : []);
            })
            .catch(error => console.error("❌ Chyba při načítání kapitol:", error));
    }, [id]);


    const [showModalDel, setShowModalDelete] = useState(false);
    const deleteModalOpen = () => setShowModalDelete(true);
    const deleteModalClose = () => setShowModalDelete(false);

    const [showModalChars, setShowModalChar] = useState(false);
    const charsModalOpen = () => setShowModalChar(true);
    const charsModalClose = () => setShowModalChar(false);

    const [showModalNC, setShowModalNC] = useState(false);
    const newCharModalOpen = () => setShowModalNC(true);
    const newCharModalClose = () => setShowModalNC(false);

    const [showModalChapters, setshowModalChapters] = useState(false);
    const showModalChaptersOpen = () => setshowModalChapters(true);
    const showModalChaptersClose = () => setshowModalChapters(false);

    return (
        <div>
            {showModalNC && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content bg-light">
                            <div className="modal-header">
                                <h5 className="modal-title">Přidat postavu do příběhu {thisBook.book.title}</h5>
                                <button type="button" className="btn-close" onClick={newCharModalClose}></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="mb-3">
                                        <label htmlFor="name">Jméno</label>
                                        <input required type="text" id="name" className="form-control" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="img">Fotka</label>
                                        <input required type="url" placeholder="https://i.imgur.com/_____.png" id="img" className="form-control" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="detail">Info</label>
                                        <textarea id="detail" className="form-control" rows="5"></textarea>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-success"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNewCharacterModal(thisBook, newCharModalClose);
                                    }}
                                >
                                    Přidat novou postavu
                                </button>
                                <button className="btn btn-secondary" onClick={newCharModalClose}>
                                    Zrušit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModalChapters && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content bg-light">
                            <div className="modal-header">
                                <h5 className="modal-title">Kapitoly příběhu {thisBook.book.title}</h5>
                                <button type="button" className="btn-close" onClick={showModalChaptersClose}></button>
                            </div>
                            <div className="modal-body">
                                {Array.isArray(allChaptersLinks) && allChaptersLinks.length > 0 ? (
                                    allChaptersLinks.map((chapter, index) => (
                                        <div className="lead text-center" key={index}>
                                            <a href={`/book/${chapter.book_id}/${chapter.chapter_number}`}>{chapter.title}</a>
                                        </div>
                                    ))
                                ) : (
                                    <p>Žádné kapitoly k dispozici.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModalDel && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content bg-warning xg">
                            <div className="modal-header">
                                <h5 className="modal-title">Smazat příběh {thisBook.book.title}?</h5>
                                <button type="button" className="btn-close" onClick={deleteModalClose}></button>
                            </div>
                            <div className="modal-body">
                                <p>Potvrzením dojde k <b>trvalému</b> smazání celého příběhu. Tento krok <b>není možné</b> vzít zpět.</p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-danger" onClick={(e) => deleteStory(thisBook.book.id, e)}>
                                    Souhlasím, chci příběh smazat
                                </button>
                                <button className="btn btn-secondary" onClick={deleteModalClose}>
                                    Zrušit a zachovat můj příběh
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModalChars && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Postavy v příběhu {thisBook.book.title}</h5>
                                <button type="button" className="btn-close" onClick={charsModalClose}></button>
                            </div>
                            <div className="modal-body">
                                <div>{(
                                    (thisBook.chars ? (
                                        (thisBook.chars.map((char, i) => (
                                            <div className="text-center border p-4">
                                                <Row>
                                                    <Col lg={4}>
                                                        <img style={{height: '150px'}} className="rounded"
                                                             src={char.image}
                                                             alt=""/>
                                                    </Col>
                                                    <Col className="mt-4 justify-content-center">
                                                        <div className="text-end">
                                            <span style={{cursor: "pointer"}} onClick={() => (deleteChar(char.id, thisBook))}>
                                                <i className="bi bi-trash3-fill"></i>
                                            </span>
                                                        </div>
                                                        <div className="bold">{char.name}</div>
                                                        <div>{char.detail}</div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )))
                                    ) : (
                                        <div>Žádné postavy nenalezeny</div>
                                    ))
                                )}</div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={charsModalClose}>
                                    Zavřít
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {thisBook ? (
                <div>
                <div className="border-bottom bottom-shadow pt-4 mb-4 pb-4 text-center">
                        {(thisBook.book.public == 0 ? (
                            <Alert variant="warning">
                                <i className="bi bi-exclamation-triangle-fill"></i> Tento příběh ještě nebyl zveřejněn a vidíš
                                jej
                                pouze ty! <i className="bi bi-exclamation-triangle-fill"></i>
                            </Alert>
                        ) : (null))}
                        <Row>
                            <Col lg={5} xs={12} className="text-lg-end text-center">
                                <img src={thisBook.book.image} className="img-fluid shadow rounded coverphoto" alt=""/>
                            </Col>
                            <Col lg={7} xs={12} className="text-lg-start text-center">
                                <div className="fs-1 bold better-lead">{capitalizeFirstLetter(thisBook.book.title)}</div>
                                <div className="description">{thisBook.book.description}</div>
                                <div className="my-3">
                                    <div><i className="bi bi-eye-fill"></i> {Math.floor(thisBook.book.views/2)}</div>
                                    {(thisBook.book.stars ? (
                                        <div><i className="bi bi-star-fill"></i> 0</div>
                                    ) : null)}
                                </div>
                                <div className="my-3">
                                    <div style={{cursor: "pointer"}} onClick={showModalChaptersOpen}><i class="bi bi-list-ol"></i> Kapitola {(thisBook.chapter.chapter_number ? thisBook.chapter.chapter_number : 1)}/{(thisBook.allchapters.total > 0 ? thisBook.allchapters.total : 1)}</div>
                                    <div><i class="bi bi-calendar-event-fill"></i> Vytvořeno {formatDate(thisBook.book.created_at)}
                                    </div>
                                    <div><i class="bi bi-calculator-fill"></i> Počet slov: {formatNumber(thisBook.chapterCount)}</div>
                                </div>
                                {(thisBook.book.public == 1 ? (
                                    <div className="my-3">
                                        <a target="_blank" href={twitter}><i className="bi bi-twitter-x"></i> Sdílet na
                                            X</a><br/>
                                        <a target="_blank" href={facebook}><i className="bi bi-facebook"></i> Sdílet na
                                            Facebook</a>
                                    </div>
                                ) : (
                                    <div className="my-3"><i class="bi bi-ban"></i> Příběh není možné sdílet, když není veřejný</div>
                                ))}
                                <div className="mt-4 lead"><span className="handwriter">{thisBook.author.name}</span>
                                </div>
                                {(localStorage.getItem("mau_user_type") == "admin" || localStorage.getItem("mau_user_type") == "dev" ? (
                                    <div>
                                        {(thisBook.book.public == 0 ? (
                                        <div className="mt-5">
                                            <Button onClick={() => publicBook(1, id)} size="sm" variant="success"><i
                                                className="bi bi-eye-fill"></i> Zveřejnit příběh</Button>
                                        </div>
                                        ) : (
                                        <div className="mt-5">
                                            <Button onClick={() => publicBook(0, id)} size="sm" variant="warning"><i
                                                className="bi bi-eye-slash-fill"></i> Skrýt příběh</Button>
                                        </div>
                                        ))}
                                    </div>
                                ) : (null))}
                                <div className="mt-3">
                                    <Button className="btn btn-light" onClick={charsModalOpen}>
                                        <i className="bi bi-people-fill"></i> Seznam postav tohoto příběhu
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Container>
                        <div className="lead mb-4 text-center">Kapitola {(thisBook.chapter.chapter_number ? thisBook.chapter.chapter_number : 1)}.</div>
                        <div className="no-copy bkcnt" id="book-content" onCopy={handleCopy} onCut={handleCopy} onContextMenu={handleCopy} dangerouslySetInnerHTML={{ __html: thisBook.chapter.content }}></div>
                        <div className="my-3 text-center">
                            {(Number(thisBook.allchapters.total) > 1 ? (
                                (Number(thisBook.chapter.chapter_number) < Number(thisBook.allchapters.total) && Number(thisBook.chapter.chapter_number) == 1 ? (
                                    <>
                                        <Button onClick={NextChapter} variant={"success"}><i
                                            className="bi bi-arrow-bar-right"></i> Další</Button>
                                    </>
                                ) : (
                                    (Number(thisBook.chapter.chapter_number) < Number(thisBook.allchapters.total) && Number(thisBook.chapter.chapter_number) > 1 ? (
                                        <>
                                            <Button className="mx-1" size="sm" onClick={PrevChapter} variant={"success"}><i
                                                className="bi bi-arrow-bar-left"></i> Předchozí</Button>

                                            <Button size="sm" onClick={NextChapter} variant={"success"}><i
                                                className="bi bi-arrow-bar-right"></i> Další</Button>
                                        </>
                                    ) : (
                                        (Number(thisBook.chapter.chapter_number) == Number(thisBook.allchapters.total) ? (
                                            <>
                                                <Button onClick={PrevChapter} variant={"success"}><i
                                                    className="bi bi-arrow-bar-left"></i> Předchozí</Button>
                                            </>
                                        ) : (null))
                                    ))
                                ))
                            ) : (null))}
                        </div>
                    </Container>
                </div>
            ) : (
                <div>Načítání...</div>
            )}
            <hr/>
            {CheckAdmin() ? (
                <Container className="mt-5 pb-5">
                    <form onSubmit={sendNewText}>
                        <div className="lead mb-3">Tvoje kouzelná část</div>
                        <TextEditor setNewText={setNewText}/>
                        <Row>
                            <Col>
                                <button type="submit" className="btn w-100 btn-success"><i
                                    class="bi bi-pencil-fill"></i> Odeslat
                                </button>
                            </Col>
                            <Col>
                                <select onChange={(e) => setNewTextChapter(e.target.value)}
                                        className="form-control mb-3" name="chapter">
                                    <option selected value="0">Do této kapitoly</option>
                                    <option value="1">Do nové kapitoly</option>
                                </select>
                            </Col>
                        </Row>
                    </form>
                    <Row className="mt-5">
                        <Col>
                            <Button className="btn btn-success btn-sm" onClick={newCharModalOpen}>
                                <i className="bi bi-person-fill-add"></i> Přidat novou postavu
                            </Button>
                        </Col>
                        <Col>
                            <div className="text-end">
                                <Button className="btn btn-danger btn-sm" onClick={deleteModalOpen}>
                                    <i className="bi bi-trash-fill"></i> Smazat příběh
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            ) : (null)}
        </div>
    );
}

export default OneBook;
